export const Constants = {
  GET_DATA: 'Chart.GET_DATA',
  SET_DATA: 'Chart.SET_DATA',
  SET_LOADING: 'Chart.SET_LOADING',
  GET_DATA_API: '/api/v1/report/dashboard_chart_thang_nam'
}
function buidChart(data) {
  if (!data || data.length == 0) {
    return {
      labels: [],
      datasets: [
        {
          label: 'doanh số',
          data: [0, 0],
        }
      ]
    }
  }
  else {
    let labels = [];
    let datas = [];
    let colors = [];
    for (var i = 0; i < data.length; i++) {
      let item = data[i];
      labels.push(item["NgayBan"]);
      datas.push(item["ThanhTien"]);
    }
    let charts = {
      labels: labels,
      datasets: [
        {
          label: 'doanh số',
          data: datas,
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'red',
          pointBackgroundColor: 'red',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'red',
          pointHoverBorderColor: 'red',
          pointHoverBorderWidth: 5,
          pointRadius: 1,
          pointHitRadius: 10,
        }
      ]
    }
    return charts
  }
}

export const getData = (formData) => {
  return {
    type: Constants.GET_DATA,
    payload: formData
  }
}

export const setData = (data) => {
  return {
    type: Constants.SET_DATA,
    payload: data ? buidChart(data) : buidChart([])
  }
}

export const setLoading = (flag) => {
  return {
    type: Constants.SET_LOADING,
    payload: flag
  }
}


// WEBPACK FOOTER //
// ./src/components/Chart/actions.js